module.exports = __webpack_public_path__ + "static/person6-54901c58bea46e4183f5db1535d1a7f9.png";